<template>
<div v-bind:class="{ 'black_bg': this.black, 'white_bg': !this.black }">
  <div class="footer__menu">
    <ul>
      <li v-on:click="showHisto" v-tooltip.top-center="ngram">Histogram</li>
      <!-- <li v-on:click="showPoms" v-tooltip.top-center="poms">ID's</li> -->
      <li class="right">
        <a href="https://chrome.google.com/webstore/detail/888-zoeker/fmodplkopebakajogdkfhodjhcecabbb?hl=nl">Chrome-extensie</a>
      </li>
    </ul>
  </div>
</div>
</template>

<script>
import Vue from 'vue'
import VTooltip from 'v-tooltip'

Vue.use(VTooltip)

export default {
  name: 'Footer',
  data: function () {
    return {
      ngram: 'Toon grafiek met resultaten<br/>gegroepeerd per maand',
      poms: 'Programmalijst',
      nyi: 'Nog niet mogelijk',
      ext: 'Skip gelijk naar het<br/>het juiste fragment',
      lichtkrant: 'Jep, dit is een ouderwetse lichtkrant. Make the web great again. | Search operators: -Feyenoord Ajax [Wel Ajax, geen Feyenoord], Feyenoord | Ajax [Ajax of Feyenoord] | We + ging* [We en woorden die de letters begin bevatten] | Pegtold~ [fuzzy search, toont resultaten met Pechtold] | v?s [vervangt een karakter] | "Exact deze vier woorden" | '
    }
  },
  props: ['black'],
  beforeUpdate: function () {
    console.log('update')
  },
  methods: {
    showHisto: function () {
      // console.log(this.black)

      this.$emit('showHisto')
    }
  }
}
</script>

<style scoped>
div {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 80%;
  height: 30px;
  line-height: 30px;
  border-top: 1px solid #707070;
  /* background: black; */
  color: #707070;
  font-family: fl-mono;
  z-index: 15;
  margin-left: 20%;
}

.footer__menu {
  margin-left: 20%;
}

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  li {
    line-height: 30px;
    float: left;
    border-left: 1px solid #707070;
    padding: 3px 10px 0 10px;
    font-size: 16px;
    text-transform: uppercase;
    cursor: pointer;
  }

  li:first-child {
    border-right: 1px solid #707070;
  }

  li:hover {
    background: #707070 !important;
    color:#383838 !important;
  }

  .right {
    float: right;
  }

  a {
    text-decoration: none;
    color: #707070;
  }

  a:visited {
    color: #707070;
  }

  a:hover {
    color: #383838 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue